import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import Configurator from './Configurator';
import {
  initializeUnitPreview, initializePromotion, changeRoom, initializeSections, initializeSummaryCameras,
} from '../../model/configuratorSlice';

// The authenticated admin fetches the data. Only that iframe parent may supply it;
// no customer token or admin credentials are passed into the configurator.
const UnitPreview = () => {
  const dispatch = useDispatch();
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (window.parent === window || !document.referrer) {
      setError('Abre esta vista desde la inspección de viviendas del administrador.');
      return undefined;
    }
    const parentOrigin = new URL(document.referrer).origin;
    const previewId = new URLSearchParams(window.location.search).get('previewId');
    let accepted = false;
    const receive = (event) => {
      if (event.source !== window.parent || event.origin !== parentOrigin
        || event.data?.type !== 'unit-preview-load' || event.data.previewId !== previewId || accepted) return;
      const { configuration, unit } = event.data.payload || {};
      if (!unit?.id || !configuration?.settings || !Array.isArray(configuration?.categories)
        || !Array.isArray(configuration?.rooms) || !configuration.rooms.length) {
        setError('Esta vivienda no tiene una configuración con estancias disponibles.');
        window.parent.postMessage({ type: 'unit-preview-error', previewId }, parentOrigin);
        return;
      }
      const firstRoom = configuration.rooms.find(room => room.categories?.some((entry) => {
        const category = configuration.categories.find(item => item.id === entry.id);
        return !category || !category.disabled;
      }));
      if (!firstRoom) {
        setError('Esta vivienda no tiene estancias disponibles.');
        window.parent.postMessage({ type: 'unit-preview-error', previewId }, parentOrigin);
        return;
      }
      accepted = true;
      dispatch(initializeUnitPreview(unit));
      dispatch(initializePromotion(configuration));
      dispatch(changeRoom(firstRoom.id));
      dispatch(initializeSections());
      dispatch(initializeSummaryCameras());
      setLoaded(true);
      window.parent.postMessage({ type: 'unit-preview-loaded', previewId }, parentOrigin);
    };
    window.addEventListener('message', receive);
    window.parent.postMessage({ type: 'unit-preview-ready', previewId }, parentOrigin);
    return () => window.removeEventListener('message', receive);
  }, [dispatch]);

  if (error) return <p role="alert">{error}</p>;
  if (!loaded) return <p>Cargando configuración de la vivienda…</p>;
  return <Configurator />;
};

export default UnitPreview;
